<template>
    <div>
        <breadcrumb :routerList="[{to:'/xiangmu/Pdetails',title:'项目管理'},{title:'项目详情'}]"/>
        <div class="bigDiv">
            <div class="h-piece">
                <div>
                    <span>国外订单详情</span>
                    <hr>
                    <el-form :model="formLabelAlign" :label-position="right" :rules="rules" ref="formLabelAlign"
                             :inline="true" class="demo-ruleForm h-formbLine ">
                        <el-form-item label="项目编号" class="h-elformWrap-2">
                            <el-select v-model="formLabelAlign.type1">
                                <el-option label="类型一" value="type1"></el-option>
                                <el-option label="类型二" value="type2"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="分类" class="h-elformWrap-2" prop="name">
                            <el-select v-model="formLabelAlign.type2" placeholder="自产">
                                <el-option label="类型一" value="type1"></el-option>
                                <el-option label="类型二" value="type2"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-form>
                </div>
                <div class="h-formLine product">
                    <el-form :model="formLabelAlign" :label-position="right" ref="formLabelAlign"
                             :inline="true" class=" h-formbLine">
                        <el-form-item label="产品名称" class="h-elformWrap-2">
                            <el-input v-model="formLabelAlign.name" placeholder="冷冻柜"></el-input>
                        </el-form-item>
                        <el-form-item label="产品型号" class="h-elformWrap-2" >
                            <el-input v-model="formLabelAlign.xinhao"></el-input>
                        </el-form-item>
                        <el-form-item label="订单数量" class="h-elformWrap-2 " >
                            <el-input v-model="formLabelAlign.liang" placeholder="20"></el-input>
                        </el-form-item>
                        <el-form-item label="基准价" class="h-elformWrap-2" >
                            <el-input v-model="formLabelAlign.jizhunjia1" placeholder="20"></el-input>
                        </el-form-item>
                        <el-form-item label="基准价" class="h-elformWrap-2" >
                            <el-input v-model="formLabelAlign.jizhunjia2" placeholder="20"></el-input>
                        </el-form-item>
                        <el-form-item label="基准价" class="h-elformWrap-2" >
                            <el-input v-model="formLabelAlign.jiazhunjia3" placeholder="20"></el-input>
                        </el-form-item>
                    </el-form>
                </div>
                <img src="../../../assets/images/pimg/jiahao.png" alt="">
                <div class="h-formLine n-biao">
                    <el-form :model="formLabelAlign" :label-position="right"  ref="formLabelAlign"
                             :inline="true" class="demo-ruleForm h-formbLine" >
                        <el-form-item label="订单类型" class="h-elformWrap-2"  required="true">
                            <el-select v-model="formLabelAlign.dingdan" placeholder="请选择" >
                                <el-option label="类型一" value="type1"></el-option>
                                <el-option label="类型二" value="type2"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="渠道" class="h-elformWrap-2 " required="true">
                            <el-select v-model="formLabelAlign.qudao" placeholder="请选择">
                                <el-option label="类型一" value="type1"></el-option>
                                <el-option label="类型二" value="type2"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="收货单位名称" class="h-elformWrap-2 "  required="true" >
                            <el-input v-model="formLabelAlign.danwei" placeholder="300"></el-input>
                        </el-form-item>
                        <el-form-item label="联系人" class="h-elformWrap-2" required="true" >
                            <el-input v-model="formLabelAlign.person" placeholder="3968.5554"></el-input>
                        </el-form-item>
                        <el-form-item label="电话" class="h-elformWrap-2" required="true" >
                            <el-input v-model="formLabelAlign.phone" placeholder="556.587.57" ></el-input>
                        </el-form-item>
                        <el-form-item label="手机" class="h-elformWrap-2"  required="true"  >
                            <el-input v-model="formLabelAlign.call" placeholder="556.587.57"></el-input>
                        </el-form-item>
                        <el-form-item label="所在区域" class="h-elformWrap-2"  required="true" >
                            <el-select v-model="formLabelAlign.area" placeholder="请选择" >
                                <el-option label="类型一" value="type1"></el-option>
                                <el-option label="类型二" value="type2"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="邮编" class="h-elformWrap-2" required="true"  >
                            <el-input v-model="formLabelAlign.youbian" placeholder="556.587.57"></el-input>
                        </el-form-item>
                        <el-form-item label="街道地址" class="h-elformWrap-2"  required="true" >
                            <el-input v-model="formLabelAlign.street" placeholder="556.587.57"
                                      class="adderss"></el-input>
                        </el-form-item>
                        <br>
                        <el-form-item label="预计收货日期" class="h-elformWrap-2" required="true" >
                            <template>
                                <div class="block">
                                    <el-date-picker
                                            v-model="value1"
                                            type="date"
                                            placeholder="--选择--">
                                    </el-date-picker>
                                </div>
                            </template>
                        </el-form-item>
                        <el-form-item label="四方关系" class="h-elformWrap-2" required="true" >
                            <el-select v-model="formLabelAlign.guanxi" placeholder="请选择">
                                <el-option label="类型一" value="type1"></el-option>
                                <el-option label="类型二" value="type2"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="发片类型" class="h-elformWrap-2" required="true" >
                            <el-select v-model="formLabelAlign.fapian" placeholder="请选择">
                                <el-option label="类型一" value="type1"></el-option>
                                <el-option label="类型二" value="type2"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-form>
                </div>
            </div>
            <el-row class="row">
                <el-button class=" zancun" style="width:2rem;">盈利测算</el-button>
                <el-button style="width:2rem; background-color:rgb(41, 124, 219);color:rgb(255, 255, 255);">提交订单
                </el-button>
                <el-button style="width:1.3rem;">取消</el-button>
            </el-row>
        </div>
    </div>
</template>
<style scoped>
    .h-piece{
        height:600px;
    }
    .block{
        position: relative;
        left: 110px;
        top: -20px;
    }
    .adderss{
        position: relative;
        left: 82px;
        top: -20px;
    }
 
   
    
   
    img {
        height: 30px;
        position: relative;
        left: 15rem;
        top: -2rem;
    }

    .row {
        margin: 15px 0 30px 400px;
    }

    .zancun {
        background-color: #24b5b8;
        color: white;
    }

    span {
        margin: 0 0 20px 20px;
        font-size: 14px;
    }

    hr {
        margin: 25px 20px;
        border: none;
        height: 1px;
        background-color: rgb(222, 226, 226);
    }

    .h-piece {
        margin: 20px
    }

    .product {
        border: 1px solid rgb(206, 204, 204);
        width: 93%;
        padding-top: 40px;
        border-radius: 4px;
        background-color: rgb(249, 251, 252);
        margin-left: 10px;
        margin-bottom: 35px;
        height: 120px;
    }

  
</style>
<style>
</style>

<script>
    export default {
        data() {
            return {
                value1:'',
                formInline: {
                    user: '',
                    region: '',
                    date1: '',
                    date2: '',
                    date3: '',
                },
                formLabelAlign: {
                    guanxi:'',
                    fapian:'',
                    type1:'',
                    type2:'',
                    name: '',
                    contact: '',
                    contactInfo: '',
                    type: '',
                    date3: '',
                    explain: '',
                    xinhao:'',
                    liang:'', 
                    jizhunjia1:'', 
                    jizhunjia2:'', 
                    jiazhunjia3:'',
                    qudao:'', 
                    danwei:'', 
                    person:'', 
                    phone:'', 
                    call:'', 
                    area:'', 
                    youbian:'', 
                    street:'',
                    dingdan:'',
                },
                rules: {
                    name: [
                        {required: true, message: '请输入项目名称', trigger: 'blur'},
                    ],
                }
            }
        },
    }
</script>


